import React from 'react';
import './TicTacToe.css';

export default class TicTacToe extends React.Component {
  state = {
    isX: true,
    win:"R"
  }

  handlePlay = (event) => {
    const target = event.target.closest("td");
    const gameBoard = event.target.closest("tbody");

    if(!this.checkIfGameFinish(gameBoard)
      &&this.state.win === "R"
      && target.textContent === "") {
      if(this.state.isX) {  
        target.textContent = "X";
        this.checkGameStatus(gameBoard,"X");
      }else {
        target.textContent = "O";
        this.checkGameStatus(gameBoard,"O");
      }
      this.setState({ isX : !this.state.isX })
    }
    
  }

  checkGameStatus(gameBoard, pawn) {
    const winConditions = [[0,1,2], [3,4,5], [6,7,8], [0,3,6], [1,4,7], [2,5,8], [0,4,8], [6,4,2]];
    let p = [];
    const allC =  gameBoard.querySelectorAll("td");

    allC.forEach(c => {
      if(c.textContent === pawn) {
        p.push(c.getAttribute("data-key"));
      }
    });

    winConditions.forEach(condition => {
      const ifWin = condition.every(c => p.includes(c.toString()));
      
      if(ifWin)
      {
        this.setState({win:pawn})

        let index = 0;
        const iv = setInterval(() => {
          allC[condition[index]].style.color = "rgb(204, 102, 0)";
          index++;

          if(index > condition.length-1) 
            clearInterval(iv);
        }, 100);
      }
    })

  }

  checkIfGameFinish(gameBoard) {
    let isFull = true;

    gameBoard.querySelectorAll("td").forEach(c => {
      if(c.textContent === "")
        isFull=false;
    })

    return isFull;
  }

  handleRestart = (event) => {
    //garbage code 
    const gameBoard =event.target.parentNode.parentNode.parentNode.querySelector("tbody");
    let index = 0;
    const allC = gameBoard.querySelectorAll("td");

    const to = setInterval(() => {
      allC[index].textContent="";
      allC[index].style.color = "rgb(72, 86, 32)";
      index ++;

      if(index === 9)
        clearInterval(to);
    }, 100);

    this.setState({win:"R"})

  }
 
  render() {
    return (
      <React.Fragment>
        <h5>Tic Tac Toe</h5>
        <div className="tictactoe-status">
          <div
            onClick={(e) => this.handleRestart(e)}
          >
            {this.state.win}
          </div>
          <div>WIN</div>
        </div>
        <table className="tictactoe-body">
          <tbody
            onClick={(e) => this.handlePlay(e)}
          >
            <tr>
              <td data-key="0"></td>
              <td data-key="1"></td>
              <td data-key="2"></td>
            </tr>
            <tr>
              <td data-key="3"></td>
              <td data-key="4"></td>
              <td data-key="5"></td>
            </tr>
            <tr>
              <td data-key="6"></td>
              <td data-key="7"></td>
              <td data-key="8"></td>
            </tr>
          </tbody> 
        </table>
      </React.Fragment>
    )
  }
}